module.exports = __webpack_public_path__ + "static/media/ic-restore.075f6633.svg";